import { render } from "./FriedRiceBody.vue?vue&type=template&id=3eb61554&scoped=true"
import script from "./FriedRiceBody.vue?vue&type=script&lang=js"
export * from "./FriedRiceBody.vue?vue&type=script&lang=js"

import "./FriedRiceBody.vue?vue&type=style&index=0&id=3eb61554&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb61554"]])

export default __exports__